<template>
    <!-- 小区详情 -->
    <div id="communityDetail">
        <!-- 详情 -->
        <div v-if="type == 0">
            <van-cell title="名称" :value="communityDetail.name" />
            <van-cell title="城市" :value="communityDetail.cityName" />
            <van-cell title="sku套餐" :value="communityDetail.priceSkuName" />
            <van-cell title="水电燃套餐" :value="communityDetail.priceWEGName" />
            <van-cell title="物业费单价" :value="communityDetail.propertyFeePer+'元/平米'" />
            <van-cell title="地址" :value="communityDetail.address" />
            <van-cell title="经度" :value="communityDetail.lng" />
            <van-cell title="纬度" :value="communityDetail.lat" />
            <van-cell title="行政区域" :value="communityDetail.areaName" />
            <van-cell title="商圈" :value="communityDetail.tradeAreaName" />
            <van-cell title="所属门店" :value="communityDetail.storeName" />
            <van-cell title="楼栋单位" :value="buildingTypeList[communityDetail.buildingType-1]" />
            <van-cell title="地铁" :value="communityDetail.subwayVOList.join(',')" />
            <van-cell title="备注" :value="communityDetail.remark" />
        </div>
        <!-- 审批 -->
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="type == 1">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus-1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
            </van-step>
        </van-steps>
        <van-form ref="form" label-width="110px" input-align="left" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <div v-if="$route.query.type" style="height:1.2rem;"></div>
        <div class="btn" v-if="$route.query.type">
            <van-button v-if="type == 0" @click="type = 1" type="primary">审批</van-button>
            <van-button v-if="type == 1" @click="type = 0" type="primary">详情</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div>
        <!-- <van-image-preview v-model="imgShow" :startPosition="imgIndex" :images="images"></van-image-preview> -->
        <!-- 加载 -->
        <div class="loading" v-if="loading"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestCommunityDetail,
    requestWorkflowDetail1,
    requestWorkflowSubmit
} from "@/api";
import { mergeRowCol, accAdd, accSub, formatDate } from "@/utils/index";
export default {
    name: "communityDetail",
    data() {
        return {
            active: 0,
            communityDetail: {
                subwayVOList: []
            },
            //审批
            type: 0, //切换0.详情/1.审批
            saveLoad: false,
            trackRecordList: [{ status: "" }],
            loading: true,
            formData: {
                remark: ""
            }
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "quitTypeList",
            "returnOrderStatus",
            "payTypeList",
            "approvalStatusList",
            "buildingTypeList"
        ])
    },
    created() {
        this.getDetail();
        if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestCommunityDetail(this.$route.query.id)
                .then(res => {
                    res.data.communitySubwayVOList =
                        res.data.communitySubwayVOList || [];
                    let subwayVOList = [];
                    res.data.communitySubwayVOList.forEach(d => {
                        subwayVOList.push(d.lineName);
                    });
                    res.data.subwayVOList = subwayVOList;
                    this.communityDetail = res.data;
                    this.loading = false;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        //查流程
        getWorkflow() {
            //审批待办
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestWorkflowDetail1(this.$route.query.agentId)
                .then(res => {
                    this.trackRecordList = res.data ? res.data : [];
                    this.trackRecordList[0].status == 5
                        ? (this.type = 1)
                        : (this.type = 0);
                    // this.loading = false;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        accSub(num1, num2) {
            return accSub(num1, num2);
        },
        //审批提交
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            if (type == 1) {
                //同意
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            } else {
                //驳回
                this.$refs["form"].validate().then(valid => {
                    this.$dialog.confirm({
                        title: "提示",
                        message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        beforeClose: (action, done) => {
                            if (action === "confirm") {
                                this.saveLoad = true;
                                requestWorkflowSubmit(param)
                                    .then(res => {
                                        this.$toast.success("审批成功");
                                        this.getWorkflow();
                                        this.saveLoad = false;
                                        done();
                                    })
                                    .catch(err => {
                                        this.saveLoad = false;
                                        done(false);
                                    });
                            } else {
                                done();
                            }
                        }
                    });
                });
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#communityDetail {
    .colorC {
        color: $colorC;
    }
    .theme-color {
        color: $theme-color;
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
    .van-steps {
        text-align: left;
        padding-left: 2rem;
        /deep/.van-step__title {
            padding-left: 0.3rem;
            p {
                padding-top: 0.2rem;
            }
        }
    }
}
</style>
